import { render } from "./ArrayImagesField.vue?vue&type=template&id=b4343144"
import script from "./ArrayImagesField.vue?vue&type=script&lang=js"
export * from "./ArrayImagesField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ArrayImagesField.vue"]])

export default __exports__